<h2 mat-dialog-title class="dialog-title !text-xl !font-bold !mb-4">{{ title }}</h2>

<mat-dialog-content class="dialog-content">
  <p class="mb-4">{{ description }}</p>

  <mat-radio-group [(ngModel)]="tipoProcessamento" class="radio-group-flex">
    <mat-radio-button [value]="TipoProcessamentoRecorrenciaEnum.ApenasEsta">
      Apenas esta conta
    </mat-radio-button>
    <mat-radio-button [value]="TipoProcessamentoRecorrenciaEnum.Proximas">
      Próximas contas em aberto a partir desta
    </mat-radio-button>
    <mat-radio-button [value]="TipoProcessamentoRecorrenciaEnum.TodasEmAberto">
      Todas as contas em aberto deste lançamento
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions mt-6">
  <button mat-flat-button class="btn-secondary mr-2" (click)="close()">{{ buttonClose }}</button>
  <button mat-flat-button class="btn-primary" (click)="confirm()">{{ buttonConfirm }}</button>
</mat-dialog-actions>